import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SettingTextField from "../../../components/SettingTextField";
import SettingSelectField from "../../../components/SettingSelectField";
import SelectizeTextField from "../../../components/SelectizeTextField";
import styles from "./Course.module.css";

const CourseAddForm = ({
  course,
  setCourse,
  courseType,
  handleOnChaneCourseType,
  courseCategories,
  setCourseCategories,
  onAddCourse,
  categoryList,
  theme_mode,
  error,
  CourseTypeList,
}) => {
  return (
    <>
      <SettingTextField
        page={"course"}
        value={course}
        setValue={setCourse}
        label={"Add Courses"}
        placeholder={"Type course name"}
        required={true}
        variant={"filled"}
        backgroundColor={theme_mode.inputBg4}
        error={course?.length ? "" : error?.course}
      />
      <Box mt={2}>
        <SettingSelectField
          page={"course"}
          value={courseType}
          setValue={handleOnChaneCourseType}
          editable={true}
          placeholder={"Select course type"}
          required={true}
          variant={"filled"}
          menuList={CourseTypeList}
          backgroundColor={theme_mode.inputBg4}
          error={error?.courseType}
        />
      </Box>
      <Box mt={2}>
        <SelectizeTextField
          page={"course"}
          tagColor={theme_mode.inputBg5}
          value={courseCategories}
          onChange={(val) => {
            setCourseCategories(val);
          }}
          backgroundColor={theme_mode.inputBg4}
          options={categoryList}
          variant={"filled"}
          label={""}
          placeholder={courseCategories.length ? "" : "Select Categories"}
          error={courseCategories?.length ? "" : error?.catgeories}
        />
      </Box>
      <Box
        my={3}
        onClick={onAddCourse}
        className={styles.addBtn}
        style={{ backgroundColor: theme_mode.btnBg4 }}
      >
        <Typography
          className={styles.addBtnText}
          style={{ color: theme_mode.btnText }}
        >
          Add Course
        </Typography>
      </Box>
    </>
  );
};

export default CourseAddForm;
